<template>
  <div class="notification" :class="{ 'is-success': isSuccess }">
    <Sprite :name="icon"/>
    <span>{{content}}</span>
  </div>
</template>

<script>
import Sprite from '@/components/Sprite'

export default {
  name: 'Notification',

  props: {
    type: {
      type: String,
      required: true
    },

    content: {
      type: String,
      required: true
    }
  },

  computed: {
    icon() {
      return this.isSuccess ? 'tick' : 'close'
    },

    isSuccess() {
      return this.type === 'success'
    }
  },

  components: {
    Sprite
  }
}
</script>

<style lang="sass">
@import '../stylesheets/base/variables'
@import '../stylesheets/helpers/mixins'
@import '../stylesheets/helpers/extends'

.notification
  background: rgba(#fff, 0.95)
  font-family: $font-bold
  text-transform: uppercase
  z-index: 100
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  height: 100%
  width: 100%
  position: absolute
  top: 0
  bottom: 0
  left: 0
  z-index: 100
  padding: 20px 15px
  opacity: 0
  animation: fadeInOut 3.5s ease-in-out
  animation-fill-mode: forwards

  .sprite
    background: $color-error
    opacity: 0
    transform: scale(0.5)
    animation: scaleIn .2s .3s ease-in-out
    animation-fill-mode: forwards
    fill: #fff

  span
    font-size: 14px
    background: linear-gradient(to right, #898989, $color-error)
    background-size: 200% auto
    color: #898989
    background-clip: text
    text-fill-color: transparent
    -webkit-background-clip: text
    -webkit-text-fill-color: transparent
    animation: textLoader 4s .5s linear

  &.is-success
    .sprite
      background: $color-success

    span
      background: linear-gradient(to right, #898989, $color-success)
      background-size: 200% auto
      background-clip: text
      color: #898989
      text-fill-color: transparent
      -webkit-background-clip: text
      -webkit-text-fill-color: transparent
      animation: textLoader 4s .5s linear

  .sprite
    border-radius: 50%
    width: 60px
    height: 60px
    padding: 15px
    margin-bottom: $gap-medium
</style>
